import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Copy, ListChecks, MoreVertical, Trash2 } from 'lucide-react';

import { Tooltip } from '@/components/Tooltip/Tooltip';

import styles from './SectionKebabMenu.module.css';

interface SectionKebabMenuProps {
  disabled?: boolean;
  disabledReason?: string;
  onCopy(): void;
  onDelete(): void;
  onSelectMultiple(): void;
  sectionTitle: string;
}

export function SectionKebabMenu({
  disabled = false,
  disabledReason = 'Save your changes before copying, deleting, or selecting sections.',
  onCopy,
  onDelete,
  onSelectMultiple,
  sectionTitle,
}: SectionKebabMenuProps) {
  return (
    <DropdownMenu.Root modal={false}>
      <Tooltip content={disabled ? disabledReason : 'Section actions'}>
        <span className={styles.tooltipAnchor}>
          <DropdownMenu.Trigger asChild>
            <button
              aria-label={`Open section actions for ${sectionTitle}`}
              className={styles.trigger}
              disabled={disabled}
              type="button"
            >
              <MoreVertical aria-hidden="true" size={18} strokeWidth={2} />
            </button>
          </DropdownMenu.Trigger>
        </span>
      </Tooltip>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          className={styles.menuContent}
          sideOffset={8}
        >
          <DropdownMenu.Item className={styles.menuItem} onSelect={onCopy}>
            <Copy aria-hidden="true" size={16} />
            <span>Copy</span>
          </DropdownMenu.Item>
          <DropdownMenu.Item
            className={styles.menuItem}
            onSelect={onSelectMultiple}
          >
            <ListChecks aria-hidden="true" size={16} />
            <span>Select Multiple</span>
          </DropdownMenu.Item>
          <DropdownMenu.Separator className={styles.separator} />
          <DropdownMenu.Item
            className={[styles.menuItem, styles.dangerMenuItem].join(' ')}
            onSelect={onDelete}
          >
            <Trash2 aria-hidden="true" size={16} />
            <span>Delete</span>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
